export class FollowUrlParamMismatchException extends Error {}
